import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-logic-page" }
const _hoisted_2 = { class: "setting-logic-page__header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "setting-content" }
const _hoisted_5 = { class: "dashboard-alert" }
const _hoisted_6 = { class: "save" }

import { loadMyPropertyPreferences, myPropertyPreferences, saveMyPropertyPreferences } from '@/appLogic/view/preferences';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { openFailToSavedModal, openSuccessToSaveModal } from '@/corePagesModule/components/modal/modalActions';
import ToggleSwitch from '@/corePagesModule/components/ToggleSwitch.vue';
import { i18n } from '@/i18n';
import SettingsPageTitle from '@/settingsModule/components/SettingsPageTitle.vue';
import { onBeforeMount, reactive } from 'vue';
import { useRouter } from 'vue-router';

interface SettingLogicState {
  contentState: {
    unpaidOrderedOrderAppearance: boolean | undefined;
    orderReminderAppearance: boolean | undefined;
  };
  isEdited: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingLogicPage',
  setup(__props) {

const t = i18n.t;
const router = useRouter();

/**
 * このページで使用するStateのinterface
 */
const state = reactive<SettingLogicState>({
  contentState: {
    unpaidOrderedOrderAppearance: undefined,
    orderReminderAppearance: undefined,
  },
  isEdited: false,
});

/**
 * 設定のトグルを押した際のハンドラ
 * @param toggledKey - トグルを押した項目
 */
const onToggled = (toggledKey: string) => {
  if (!(toggledKey in myPropertyPreferences.order)) {
    return;
  }
  state.isEdited = true;
  const toggledValue = !state.contentState[toggledKey];
  state.contentState[toggledKey] = toggledValue;
};

/**
 * 保存ボタンを押した際の処理
 */
const onSave = async () => {
  state.isEdited = false;
  for (const [key, value] of Object.entries(state.contentState)) {
    if (value == null) continue;
    myPropertyPreferences.order[key] = value;
  }
  try {
    const res = await waitLoading(saveMyPropertyPreferences(), t('保存中…'), '');
    console.log(res);
    if (res == null) throw new Error();
    await openSuccessToSaveModal();
  } catch (e) {
    await openFailToSavedModal();
  }
  location.reload();
};

/**
 * ダッシュボードアラート設定ボタン押下
 */
const onClickDashboardAlertSetting = () => {
  router.push('logic/dashboard-alert');
};

onBeforeMount(async () => {
  // ページロード時にIndexedDBから現在の設定情報を取得してStateに格納
  await waitLoading(loadMyPropertyPreferences(), undefined, '');
  for (const key of Object.keys(state.contentState)) {
    if (key in myPropertyPreferences.order) {
      state.contentState[key] = myPropertyPreferences.order[key] ?? true;
    }
  }
  state.isEdited = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(SettingsPageTitle, {
        label: _unref(t)('設定 > 発注・計算ロジック')
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ToggleSwitch, {
          "is-enabled": state.contentState['unpaidOrderedOrderAppearance'],
          "label-text": _unref(t)('最新在庫の日付以前の納期を持つ未入荷の発注を検知した場合、アラートで通知する'),
          onOnToggled: _cache[0] || (_cache[0] = () => onToggled('unpaidOrderedOrderAppearance'))
        }, null, 8, ["is-enabled", "label-text"]),
        _createVNode(ToggleSwitch, {
          "is-enabled": state.contentState['orderReminderAppearance'],
          "label-text": _unref(t)('発注登録・保存後にリマインド設定を表示する'),
          onOnToggled: _cache[1] || (_cache[1] = () => onToggled('orderReminderAppearance'))
        }, null, 8, ["is-enabled", "label-text"]),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_unref(t)('ダッシュボードのアラート設定')) + " ", 1),
          _createVNode(TextButton, {
            "button-style": "btn-secondary",
            onClick: onClickDashboardAlertSetting
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('詳細設定')), 1)
            ], undefined, true),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: _normalizeClass(["save__text", { invisible: !state.isEdited }])
        }, _toDisplayString(_unref(t)('未保存の設定変更があります')), 3),
        _createVNode(TextButton, { onClick: onSave }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存する')), 1)
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ]))
}
}

})